export default "__VITE_ASSET__B8VNg7Lv__"